// external scripts
import $ from "jquery";
import debug from "bows";

const log = debug('search');

class Search {
	constructor( opts ) {
		this.opts = $.extend( {}, opts );

		if ( ! $(document.body).hasClass( 'search-results' ) ) {
			log('not search results page');
			return;
		}

		this.$load = $('.facets__load a');
		this.$results = $('#solr_results');
		this.$facets = $('.facets');

		this.$load.on('click', (e) => {
			e.preventDefault();
			this.loadingHTML = $(e.currentTarget).html();
			$(e.currentTarget).html('<span class="btn__wrap">Loading...</span>');
			this.load(e.currentTarget.href);
		});

		this.$form = $('.facets__form');
		this.$checkboxes = $('.facets__checkbox').on('change', () => {
			this.$facets.css( 'opacity', '0.5' );
			this.$form.submit();
		});

		log(this);
	}

	load( url ) {
		log('load', url);

		let ajaxurl = `${url}${url.indexOf('?') > -1 ? '&' : '?'}json=1`;

		this.$facets.css( 'opacity', '0.5' );

		$.ajax({
			method: 'GET',
			headers: {
				Accept: 'application/json',
			},
			url: ajaxurl
		}).then( (response) => {
			if ( response.posts ) {
				this.$results.append( response.posts.join('') );
			}

			if ( response.next ) {
				this.$load.attr( 'href', response.next );
			} else {
				this.$load.parent().remove();
			}

			return response;
		}).always(() => {
			if ( this.loadingHTML ) {
				this.$load.html(this.loadingHTML);
			}

			this.$facets.css( 'opacity', '' );
		});
	}
}

export default {
	init: ( opts ) => {
		return new Search( opts );
	}
}
